@use 'ui/styles/core-tokens' as core;

.footer {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 50px;
  position: sticky;
  top: 100%;

  @include core.maxWidth(core.$tablet) {
    flex-wrap: wrap;
  }

  @include core.maxWidth(core.$mobile) {
    flex-direction: column;
    gap: 12px;
  }
}
